


















import {Vue, Component} from 'vue-property-decorator';

@Component
export default class DiscountTargetMember extends Vue {
  private targetType = '';
  private data = [];

  private closePopup() {
    window.close();
  }

  private initData() {
    const {memberGradeNames, memberGroupNames, targetType} : any = this.$route.query;
    this.targetType = targetType.toUpperCase();
    this.data = memberGradeNames ? memberGradeNames.split(',') : memberGroupNames.split(',');
  }

  mounted() {
    this.initData();
  }
}
